import { mapGetters } from "vuex";
import { api } from "@monolith/helpers";

export const cogsMixin = {
  computed: {
    ...mapGetters({
      cogsSuppliers: "cogsSuppliers",
      cogsProducts: "cogsProducts",
      cogsUOM: "cogsUOM",
      companyName: "companyName",
      companySettings: "companySettings",
      cogsSearchProducts: "cogsSearchProducts",
      cogsRecipeCategories: "cogsRecipeCategories",
      cogsBaseRecipes: "cogsBaseRecipes",
      cogsMenuRecipes: "cogsMenuRecipes",
      cogsSearchRecipes: "cogsSearchRecipes",
      findIngredientByID: "findIngredientByID",
      findRecipeByID: "findRecipeByID",
      findRecipeByProductID: "findRecipeByProductID",
      sites: "siteMap",
      POSProducts: "POSProducts",
      POSCategories: "POSCategories",
      POSProductLookup: "POSProductLookup",
      cogsCostData: "cogsCostData",
      cogsPercentageData: "cogsPercentageData",
      getCogsSelectedSite: "getCogsSelectedSite",
      companyGST: "companyGST",
    }),
  },

  methods: {
    async saveCOGSDocument(doc) {
      const result = await api.add_cogs_doc(doc);
      if (result) this.updateCogs("products");
      return result;
    },

    async deleteCOGSDocument() {
      this.updateCogs("products");
    },

    clearSearchQueries() {
      if ("searchQuery" in this.$data) this.searchQuery = "";
      if ("foundProducts" in this.$data) this.foundProducts = [];
      if ("foundRecipes" in this.$data) this.foundRecipes = [];
    },

    updateCogs(scope = "all") {
      if (scope === "recipes") {
        Promise.all([
          this.$store.dispatch("getCogsBaseRecipes"),
          this.$store.dispatch("getCogsMenuRecipes"),
          this.$store.dispatch("getCogsRecipeCategories"),
        ]);
        return;
      }
      if (scope === "products") {
        Promise.all([
          this.$store.dispatch("getCogsSuppliers"),
          this.$store.dispatch("getCogsProducts"),
          this.$store.dispatch("getCogsUOM"),
        ]);
        return;
      }
      Promise.all([
        this.$store.dispatch("getCogsSuppliers"),
        this.$store.dispatch("getCogsProducts"),
        this.$store.dispatch("getCogsUOM"),
        this.$store.dispatch("getCogsBaseRecipes"),
        this.$store.dispatch("getCogsMenuRecipes"),
        this.$store.dispatch("getCogsRecipeCategories"),
        this.$store.dispatch("getPOSProducts"),
        this.$store.dispatch("getPOSCategories"),
      ]);
    },

    queryCheck(query, searchFunction) {
      if (query.length > 1) {
        return searchFunction(query);
      } else {
        return [];
      }
    },

    async searchSupplierProducts(supplierName) {
      return this.cogsProducts.filter((product) => product.value.name === supplierName);
    },

    calculateMenuRecipePercentages() {
      if (!this.getCogsSelectedSite) return;

      this.cogsMenuRecipes.forEach((recipe) => {
        if (recipe.value.slug) {
          this.checkMenuRecipe(recipe.value.slug, this.getCogsSelectedSite);
        }
      });
    },

    checkMenuRecipe(prod, site) {
      let foundMenuRecipe = this.cogsMenuRecipes.find((recipe) => recipe.value.slug === prod);
      let posFound = this.POSProductLookup({
        site: site,
        prod: prod,
      });
      if (!posFound || !posFound.value) {
        return ["Product not found", 0];
      }

      if (foundMenuRecipe) {
        if ("cost" in foundMenuRecipe.value) {
          if (!posFound.value.price) {
            return [foundMenuRecipe.value.escaped, 1, 0];
          }
          let percentage = ((foundMenuRecipe.value.cost / (posFound.value.price / this.companyGST)) * 100).toFixed(2);
          if (!("percentage" in foundMenuRecipe.value) || foundMenuRecipe.value["percentage"] !== percentage) {
            foundMenuRecipe.value["percentage"] = percentage;
          }
          return [foundMenuRecipe.value.escaped, 1, percentage];
        } else {
          return [foundMenuRecipe.value.escaped, 1, 0];
        }
      } else {
        if (posFound && posFound.value && posFound.value.name) {
          return [posFound.value.name, 0];
        } else {
          return ["Unknown Product", 0];
        }
      }
    },
  },
};
